import { NEW_SELLER_SINCE_THRESHOLD } from '../constants/itemConstants.ts';

export const getIsNewSeller = (monthsSinceStartDate: number | null | undefined): boolean => {
    if (!monthsSinceStartDate) {
        return false;
    }

    return monthsSinceStartDate <= NEW_SELLER_SINCE_THRESHOLD;
};
